/**
 * useFamilyActivities — Fetches family bonding activity suggestions from the database.
 */
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { FamilyActivity } from '@/types/familyBonding';
import { logger } from '@/utils/logger';

export function useFamilyActivities() {
  return useQuery({
    queryKey: ['family-bonding-activities'],
    queryFn: async (): Promise<FamilyActivity[]> => {
      const { data, error } = await supabase
        .from('family_bonding_activities')
        .select('*')
        .eq('is_active', true)
        .order('display_order', { ascending: true });

      if (error) {
        logger.error('Error fetching family activities:', error);
        return [];
      }

      return (data || []).map((item) => ({
        id: item.id,
        title: item.title,
        description: item.description || undefined,
        icon: item.icon || 'heart',
        category: item.category || 'general',
        partnerId: item.partner_id || undefined,
        displayOrder: item.display_order || 0,
        isCustom: false,
      }));
    },
    staleTime: 1000 * 60 * 5,
  });
}
